var r;!function(r){r.CIRCULAR="circular"}(r||(r={}));export{r as ButtonVariants};
//# sourceMappingURL=enums.js.map
